import React from 'react'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {ArticleListPage} from './ArticleListPage'
import {ArticlePage} from './ArticlePage'

const ArticleWrapper = () => {
  return (
    <>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {
                    title: 'Paramètres',
                    path: '#',
                    isSeparator: false,
                    isActive: true,
                  },
                ]}
              >
                Article
              </PageTitle>
              <ArticleListPage />
            </>
          }
        />
        <Route
          path='/ajouter'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Articles', path: '/articles', isSeparator: false, isActive: true},
                ]}
              >
                Création
              </PageTitle>
              <ArticlePage />
            </>
          }
        />
        <Route
          path='/:articleId/modifier'
          element={
            <>
              <PageTitle
                breadcrumbs={[
                  {title: 'Paramètres', path: '#', isSeparator: false, isActive: false},
                  {title: 'Articles', path: '/articles', isSeparator: false, isActive: true},
                ]}
              >
                Modification
              </PageTitle>
              <ArticlePage />
            </>
          }
        />
        <Route index element={<Navigate to='/articles/liste' />} />
      </Routes>
    </>
  )
}

export {ArticleWrapper}
